export const loginSignup = {
  header: {
    mobile: {
      mb: 6,
    },
  },
};
